import { CompositeLayer } from '@deck.gl/core'
import { GeoJsonLayer } from '@deck.gl/layers'
import TagmapLayer from './TagmapLayer'
import { FeatureType } from 'stores/features'

class QuarterLayer extends CompositeLayer<any, any> {
  get type() {
    return FeatureType.Quarter
  }

  updateState() {
    const { data } = this.props
    if (data.features) {
      this.setState({
        data: data.features.sort(
          (a, b) => b.properties.area - a.properties.area
        )
      })
    } else this.setState({ data: [] })
  }

  shouldUpdateState({ changeFlags }) {
    if (!changeFlags.propsChanged) {
      return false
    }
    if (changeFlags.updateTriggersChanged) {
      return true
    }
    if (changeFlags.propsOrDataChanged) {
      return true
    }

    return false
  }

  renderLayers() {
    const { data } = this.props
    if (data.features) {
      this.setState({
        data: data.features.sort(
          (a, b) => b.properties.area - a.properties.area
        )
      })
    }

    return [
      new GeoJsonLayer(
        this.props,
        this.getSubLayerProps({
          id: 'geojson',
          parameters: {
            depthTest: false
          },
          getLineWidth: 5,
          material: false,
          updateTriggers: {
            getLineColor: this.props.updateTriggers.getLineColor,
            getFillColor: this.props.updateTriggers.getFillColor
          }
        })
      ),
      this.props.textProps &&
        new TagmapLayer(
          this.getSubLayerProps({
            id: 'text',
            data: this.state.data,
            ...this.props.textProps,
            getPosition: this.props.getPosition
          })
        )
    ]
  }
}
QuarterLayer.layerName = 'QuarterLayer'
QuarterLayer.defaultProps = {
  getPosition: {
    type: 'accessor',
    value: (d: any) => {
      const { coordinates } = d.geometry
      const latLng = [0, 0]
      const coords = coordinates[0]

      for (const coord of coords) {
        latLng[0] += coord[0]
        latLng[1] += coord[1]
      }
      return [latLng[0] / coords.length, latLng[1] / coords.length]
    }
  }
}
export default QuarterLayer
